import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import ProfessionalDevelopmentImg from "../../../../assests/plusLearning/ProfessionalDevelopmentImg.svg";

const ProfessionalDevelopmentCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#F1799A"
            title={texts.ProfessionalDevelopment}
            image={ProfessionalDevelopmentImg}
            imageAlt={texts.plusLearning}
            link={`/${pathRouts.PROFFESSIONALDEVELOPMENT}`}
        />
    );
};

export default ProfessionalDevelopmentCarouselWidget;
